import { createFileRoute } from '@tanstack/react-router';

import { EditEventPage } from '../modules/events/ui/pages/EditEventPage';

export const Route = createFileRoute('/_authenticated/dashboard/events/$eventId/edit')({
  component: EditEventPage,
  staticData: {
    breadcrumb: ['Manage', 'Events', 'Edit'],
  },
});
